import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-usertransactions',
  templateUrl: './usertransactions.component.html',
  styleUrl: './usertransactions.component.scss',
  standalone: false
})
export class UsertransactionsComponent implements AfterViewInit {
  dataSource = new MatTableDataSource<any>([]);
  displayed_columns: string[] = ['card_brand', 'subscription_plan', 'subscription_status', 'amount', 'transaction_date'];
  title: string = '';
  UUID: string = '';
  loading = true;
  total_reports: number = 0;

  // ViewChild for paginator and sort
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UsertransactionsComponent>,
    public userService: UserService
  ) {
    this.title = data.title;
    this.UUID = data.value.UUID || [];
  }

  ngOnInit() {
    this.userService.customersTransaction(this.UUID).subscribe({
      next: (transactions: any) => {
        const records = transactions.transactions || [];
        this.dataSource.data = records;
        this.total_reports = records.length;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching subscription info:', error);
      }
    });
  }

  // Set paginator and sort after view init
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  capitalize(text: string): string {
    return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : '';
  }

  getPlanName(planValue: number): string {
    switch (planValue) {
      case 0: return 'pyrocast hobbyist';
      case 1: return 'ignite hobbyist';
      case 2: return 'tune2 hobbyist';
      default: return 'Unknown';
    }
  }

  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${month} ${day}${suffix}, ${year}`;
  }

  getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
}
